import {
  CreateRequestResultVM,
  GetFavouriteIbansResponse,
  OverviewResult,
  PagedQueryResultRequestDetailsVM,
  PagedQueryResultSettlementFullDetails,
  PagedQueryResultTransactionDetails,
} from "@payping/api";

import { LOGGED_OUT } from "./constants";
import { LoggedOutAction } from "./types";

export const CASH_OUT_REQUESTS_LOADED = "CASH_OUT_REQUESTS_LOADED";
export const CASH_OUT_SETTLEMENTS_LOADED = "CASH_OUT_SETTLEMENTS_LOADED";
export const CASH_OUT_OVERVIEW_LOADED = "CASH_OUT_OVERVIEW_LOADED";
export const SET_CREATE_REQUEST_RESULT = "SET_CREATE_REQUEST_RESULT";
export const SET_REQUEST_SETTLEMENTS_RESULT = "SET_REQUEST_SETTLEMENTS_RESULT";
export const CASH_OUT_SEARCH_SETTLEMENTS_LOADED = "CASH_OUT_SEARCH_SETTLEMENTS_LOADED";
export const CASH_OUT_DEPOSIT_LOADED = "CASH_OUT_DEPOSIT_LOADED";
export const CASH_OUT_FAVORITE_IBAN = "CASH_OUT_FAVORITE_IBAN";

export const CASH_OUT_TRANSACTIONS_LOADED = "CASH_OUT_TRANSACTIONS_LOADED";

export const REPORTS_LOADED = "REPORTS_LOADED";
export const SET_REPORT_DETAILS = "SET_REPORT_DETAILS";
export const SET_TRANSACTION_ISPAID = "SET_TRANSACTION_ISPAID";
export const SET_TOTAL_TRANSACTION_COUNT = "SET_TOTAL_TRANSACTION_COUNT";
export const SET_USER_TERMINAL_LIST = "SET_USER_TERMINAL_LIST";
export interface CashOutState {
  depositList?: PagedQueryResultRequestDetailsVM;
  depositTransactionsList?: PagedQueryResultTransactionDetails;
  requestList?: PagedQueryResultRequestDetailsVM;
  settlementList?: PagedQueryResultSettlementFullDetails;
  overview?: OverviewResult;
  createdRequest?: CreateRequestResultVM;
  createRequestSettlements?: PagedQueryResultSettlementFullDetails;
  filteredSettlementList?: PagedQueryResultSettlementFullDetails;
  favouriteIbans?: GetFavouriteIbansResponse;
}
const initialState: CashOutState = {
  depositList: {
    count: 0,
    data: [],
  },
  depositTransactionsList: {
    count: 0,
    data: [],
  },
  favouriteIbans: { favouriteIbans: [] },
  filteredSettlementList: {
    count: 0,
    data: [],
  },
  overview: {
    balance: 0,
    totalWithdraw: 0,
    withdrawableBalance: 0,
  },
  requestList: {
    count: 0,
    data: [],
  },
  settlementList: {
    count: 0,
    data: [],
  },
};

export interface CashOutDepositLoadedAction {
  type: typeof CASH_OUT_DEPOSIT_LOADED;
  payload: PagedQueryResultRequestDetailsVM;
}
export interface CashOutDepositTransactionsLoadedAction {
  type: typeof CASH_OUT_TRANSACTIONS_LOADED;
  payload: PagedQueryResultTransactionDetails;
}
export interface CashOutOverviewLoadedAction {
  type: typeof CASH_OUT_OVERVIEW_LOADED;
  payload: OverviewResult;
}

export interface CashOutFavoriteIbanAction {
  type: typeof CASH_OUT_FAVORITE_IBAN;
  payload: GetFavouriteIbansResponse;
}

export interface CashOutRequestsLoadedAction {
  type: typeof CASH_OUT_REQUESTS_LOADED;
  payload: PagedQueryResultRequestDetailsVM;
}
export interface SetCashOutRequestsListAction {
  type: typeof SET_CREATE_REQUEST_RESULT;
  payload: CreateRequestResultVM;
}

export interface CashOutSettlementLoadedAction {
  type: typeof CASH_OUT_SETTLEMENTS_LOADED;
  payload: PagedQueryResultSettlementFullDetails;
}

export interface CashOutSearchSettlementsAction {
  type: typeof CASH_OUT_SEARCH_SETTLEMENTS_LOADED;
  payload: PagedQueryResultSettlementFullDetails;
}

export type CashOutActionTypes =
  | CashOutOverviewLoadedAction
  | CashOutRequestsLoadedAction
  | CashOutSettlementLoadedAction
  | SetCashOutRequestsListAction
  | LoggedOutAction
  | CashOutSearchSettlementsAction
  | CashOutDepositLoadedAction
  | CashOutFavoriteIbanAction
  | CashOutDepositTransactionsLoadedAction;

export default function cashOuts(state = initialState, action: CashOutActionTypes): CashOutState {
  if (action.type === CASH_OUT_TRANSACTIONS_LOADED) {
    return {
      ...state,
      depositTransactionsList: action.payload,
    };
  }
  if (action.type === CASH_OUT_DEPOSIT_LOADED) {
    return {
      ...state,
      depositList: action.payload,
    };
  }
  if (action.type === CASH_OUT_REQUESTS_LOADED) {
    return {
      ...state,
      requestList: action.payload,
    };
  }
  if (action.type === CASH_OUT_SETTLEMENTS_LOADED) {
    return {
      ...state,
      settlementList: action.payload,
    };
  }
  if (action.type === CASH_OUT_SEARCH_SETTLEMENTS_LOADED) {
    return {
      ...state,
      filteredSettlementList: action.payload,
    };
  }
  if (action.type === CASH_OUT_OVERVIEW_LOADED) {
    return {
      ...state,
      overview: action.payload,
    };
  }

  if (action.type === CASH_OUT_FAVORITE_IBAN) {
    return {
      ...state,
      favouriteIbans: action.payload,
    };
  }

  if (action.type === SET_CREATE_REQUEST_RESULT) {
    return {
      ...state,
      createdRequest: action.payload,
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
